import { CourseInfo, MaterialItem, WeekModule } from "@/interface/viewMaterial";
import { dataMaterial } from "@/services/View Material/fetchMaterial";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

export const useViewMaterial = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [user, setUser] = useState<any>(null);
  const [groupedMaterials, setGroupedMaterials] = useState<WeekModule[]>([]);
  const [activeMaterial, setActiveMaterial] = useState<MaterialItem | null>(
    null,
  );
  const [loading, setLoading] = useState(true);
  const [course, setCourse] = useState<CourseInfo | null>(null); // ← pakai CourseInfo

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      try {
        setUser(JSON.parse(storedUser));
      } catch (e) {
        console.error("Gagal parse user:", e);
      }
    }

    if (id) fetchMaterials(id);
  }, [id]);

  const fetchMaterials = async (courseId: string) => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const response = await dataMaterial(
        courseId,
        token,
        setGroupedMaterials,
        setActiveMaterial,
      );

      if (response?.ok) {
        setCourse(response?.ok ? await response.json() : null);
      }
    } catch (error) {
      console.error("Gagal mengambil materi:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    if (window.confirm("Are you sure you want to log out?")) {
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      navigate("/auth/Login");
    }
  };

  const handleSidebarClick = (menuName: string) => {
    navigate("/user/dashboard", { state: { tab: menuName } });
  };

  return {
    isSidebarOpen,
    isCollapsed,
    user,
    groupedMaterials,
    activeMaterial,
    loading,
    course,
    navigate,
    setIsCollapsed,
    setIsSidebarOpen,
    handleLogout,
    handleSidebarClick,
    setActiveMaterial,
  };
};
